var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.07111 3.43964V17.4507C1.07111 19.3506 2.32983 20.89 3.8827 20.89C5.43571 20.89 6.69519 19.3505 6.69519 17.4507V3.43964C6.69519 1.54067 5.43571 0.000610528 3.8827 0.000610528C2.32983 7.94227e-06 1.07111 1.54067 1.07111 3.43964Z",
    fill: "#FFFBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0065 0C15.4538 0 14.195 1.54006 14.195 3.43903V17.4501C14.195 19.35 15.4538 20.8888 17.0065 20.8888C18.5592 20.8888 19.8189 19.3499 19.8189 17.4501V3.43964C19.8182 1.54066 18.5592 0 17.0065 0Z",
    fill: "#FFFBEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.89,
    height: 20.89,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause2);
export default __webpack_public_path__ + "static/media/pause2.880966a93777294880c015effb0d1c0e.svg";
export { ForwardRef as ReactComponent };